var req = require("!!/app/node_modules/pug-loader/index.js??ref--12-1!/app/src/esn.calendar.libs/app/components/event-date-edition/event-date-edition.pug");
module.exports = (req['default'] || req).apply(req, [])